import React, {useContext} from 'react';
import Hls from 'hls.js'
import 'pure-react-carousel/dist/react-carousel.es.css';
import './Tutorial.css'
import {AppContext} from "../AppContext";

interface VideoOverlay {
    stream: MuxStreamInfo
    streamUserId: number
    streamModal: boolean
}

interface MuxStreamInfo {
    id: string,
    playback_id: string
}

export default function VideoBroadcastTopLeft(props: { videoOverlay: VideoOverlay | null }) {
    const appContext = useContext(AppContext)
    const userId = (appContext.currentUser as any).id

    const muxPlaybackId = props.videoOverlay?.stream.playback_id

    const videoWidth = 640
    const videoHeight = 360

    const playVideo = props.videoOverlay !== null && !props.videoOverlay.streamModal && userId !== props.videoOverlay.streamUserId

    if(muxPlaybackId !== null && playVideo){
        setTimeout(() => {
            const url = "https://stream.mux.com/"+muxPlaybackId+".m3u8";
            const video = document.getElementById("videoBroadcastTopLeft");

            if(video && video instanceof HTMLMediaElement) {
                // If HLS.js is supported on this platform
                if (Hls.isSupported()) {
                    const hls = new Hls();
                    hls.loadSource(url);
                    hls.attachMedia(video);
                    hls.on(Hls.Events.MANIFEST_PARSED, () => {
                        video.play();
                    });

                    // If the player can support HLS natively
                } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                    video.src = url;
                    video.addEventListener('loadedmetadata', () => {
                        video.play();
                    });
                }
            }
        }, 500)
    }

    // console.log("props.videoOverlay", props.videoOverlay)
    // console.log("playVideo", playVideo)
    return (playVideo ? <video
            width={videoWidth}
            height={videoHeight}
            id="videoBroadcastTopLeft" autoPlay={true} controls/>
        :
        <></>)
}

